import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function Project({ item, ix }) {
	const { name, sub, desc, url, fa_icon, lang_class, png } = item;
	return (
		<a key={ix} href={url} target="_blank" className="project-tile" rel="noreferrer">
			<h2 className="proj-name">{name}</h2>
			<div className="container">
				<div>
					<FontAwesomeIcon icon={fa_icon} className="proj-pic" />
				</div>
				<div className="overlay">
					<h3 className="proj-sub">{sub}</h3>
					<p className="proj-desc">{desc}</p>
					<div className="logo-container">
						{lang_class.map((lan, i) =>
							typeof lan === "string" ? (
								<i key={i} className={`${lan} applogos`}></i>
							) : (
								<FontAwesomeIcon key={i} icon={lan} className="langu applogos" />
							)
						)}
						{png &&
							png.map((i) => (
								<img key={png.indexOf(i)} src={i.src} alt={i.name} className="applogos"></img>
							))}
					</div>
				</div>
			</div>
		</a>
	);
}
